var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInformation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9702 20C5.46095 20 0.995117 15.523 0.995117 10C0.995117 4.477 5.46095 0 10.9702 0C16.4794 0 20.9452 4.477 20.9452 10C20.9452 15.523 16.4794 20 10.9702 20ZM10.9702 18C13.0866 18 15.1164 17.1571 16.6129 15.6569C18.1095 14.1566 18.9502 12.1217 18.9502 10C18.9502 7.87827 18.1095 5.84344 16.6129 4.34315C15.1164 2.84285 13.0866 2 10.9702 2C8.85374 2 6.82398 2.84285 5.32743 4.34315C3.83088 5.84344 2.99013 7.87827 2.99013 10C2.99013 12.1217 3.83088 14.1566 5.32743 15.6569C6.82398 17.1571 8.85374 18 10.9702 18ZM9.97267 5H11.9677V7H9.97267V5ZM9.97267 9H11.9677V15H9.97267V9Z",
    fill: "#0067CE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformation);
export default __webpack_public_path__ + "static/media/information.69263b97ff9652c2fd53bdcc92136b69.svg";
export { ForwardRef as ReactComponent };